import React from 'react';

import {TariffVariants} from 'features/admin';
import {MainLayout} from 'widgets/layout';


const AdminTariffVariantsPage: React.FC = () => {

    return (
        <MainLayout>
            <TariffVariants/>
        </MainLayout>
    );
};

export default AdminTariffVariantsPage;